import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  TextInput, required,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  SimpleForm,
  Edit,
  Create,
} from "react-admin";
import ShowView from "../../../components/ShowView";

export const UnitProcessorList = (props) => (

  <List {...props} perPage={100}>
    <Datagrid rowClick="edit">
      <TextField source="title" />
      <ReferenceField link="show" label="واحد مربوطه " source="unitId" reference="unit" >
        <TextField source="title" />
      </ReferenceField>

    </Datagrid>
  </List>
);

export const UnitProcessorEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect="list" >

      <TextInput source="title" validate={required()} />
      <ReferenceInput label="واحد مربوطه " source="unitId" validate={required()} reference="unit">
        <SelectInput optionText="title" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);

export const UnitProcessorShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <DateField locales={"fa-IR"} source="createdAt" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" />
    </SimpleShowLayout>
  </ShowView>
);

export const UnitProcessorCreate = (props) => (
  <Create {...props}  >
    <SimpleForm redirect="list" >

      <TextInput source="title" label="عنوان" />
      <ReferenceInput label="واحد مربوطه " source="unitId" validate={required()} reference="unit">
        <SelectInput optionText="title" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);
